import { HeartIcon, XIcon } from '@wolfejs/icons/IconMap';
import { FormattedCartItem } from '@wolfejs/ms-api-js/src/types/orders';
import {
  CartLineItem,
  CartLineItemActionButton,
  CartLineItemDetail,
  CartLineItemImage,
  CartLineItemTitle,
} from '@wolfejs/ui/Cart/CartLineItem';
import { FormatCurrency } from '@wolfejs/ui/Format';
import { cn } from '@wolfejs/ui/utils/classnames';

export type CartItemProps = {
  className?: string;
  cartItem: FormattedCartItem;
  //region: Region;
  onFavorite?: () => void;
  onDelete?: Function;
  index: number;
};

const CartItem = ({ className, cartItem, onFavorite, onDelete, index }: CartItemProps) => {
  return (
    <CartLineItem
      key={`ln-${index}`}
      className={cn('@container not-prose border-default-100 rounded-lg border bg-white p-8', className)}
    >
      <div
        className={cn(
          'flex flex-col items-center gap-4',
          // breakpoints
          '@md:flex-row @md:gap-2'
        )}
      >
        <div
          className={cn(
            'min-w-[60px] max-w-[80px]',
            // breakpoints
            '@md:mr-4'
          )}
        >
          <CartLineItemImage
            className="rounded shadow-sm"
            src={cartItem?.thumbnail ?? 'https://placehold.co/200x100'}
            alt={`${cartItem.title} Gift Card`}
            width={200}
            height={100}
          />
        </div>
        <div
          className={cn(
            'flex flex-grow items-center justify-between text-center',
            // breakpoints
            '@md:items-start @md:text-start'
          )}
        >
          <CartLineItemTitle className="flex flex-col justify-between gap-1 font-medium leading-4">
            <span className="text-lg">
              {cartItem.title}{' '}
              <span className="text-default-400">{Number(cartItem.quantity) > 1 ? `(${cartItem.quantity}x)` : ''}</span>
            </span>
            <FormatCurrency
              className="font-bold"
              numberFormatBaseProps={{
                value: cartItem.unit_price,
                displayType: 'text',
              }}
            />
          </CartLineItemTitle>
          <CartLineItemDetail className="flex text-sm">
            {onFavorite && (
              <CartLineItemActionButton
                className="text-default-300 mr-2"
                onClick={onFavorite}
                shape="circle"
                size="xs"
                variant="unstyled"
              >
                <HeartIcon className="mr-1" />
                Add to Favorites
              </CartLineItemActionButton>
            )}
            {onDelete && (
              <CartLineItemActionButton
                className="text-error-600"
                onClick={() => onDelete(cartItem.id)}
                shape="circle"
                size="xs"
                variant="unstyled"
              >
                <XIcon className="mr-1" />
                Remove
              </CartLineItemActionButton>
            )}
          </CartLineItemDetail>
        </div>
      </div>
    </CartLineItem>
  );
};

export default CartItem;
